//封装aip请求信息
import axios from 'axios';
import {Message} from 'element-ui';
import urls from "../config/urls";
import qs from "qs";

/*axios.defaults.headers.post['Content-Type'] = 'application/json';*/

/* 自定义响应拦截器 */
axios.interceptors.response.use(res => {
  // 我们一般在这里处理，请求成功后的错误状态码 例如状态码是500，404，403, res 是所有相应的信息
  console.log(res);

  // 当返回的是HTML页面时，自动跳转到登录页（通常是session过期或未登录）
  /*if (typeof res.data === 'string' && res.data.trim().startsWith('<!DOCTYPE html>')) {
   window.location.href = '/login';
   return Promise.reject(new Error('登录已过期，请重新登录'));
   }*/

  if (res.data['code'] !== 200 && res.data['code'] !== 0) {
    const msg = ((res || {}).data || {}).message || (res || {}).message || '请求失败';
    Message.error(msg);
    return Promise.reject(new Error(msg));
  } else {
    return Promise.resolve(res);
  }
},error => {
  if (error.response) {
    const status = error.response.status;
    if (urls.errors[status]) {
      Message.error(urls.errors[status]);
    } else {
      Message.error(`请求错误(${status}): ${error.message}`);
    }
  } else {
    Message.error('网络连接失败，请检查网络');
  }
  return Promise.reject(error);
});

export const get = (url,params) => {
  console.log(url + qs.stringify(params));
  return axios.get(url + qs.stringify(params),{
    timeout:36000
  });
};

export const post = (url,params,headers = {}) => {
  console.log(url + '/' + qs.stringify(params)); /*api/AirCDcl/SaveData?*/
  return axios({
    method:'post',url:url,data:JSON.stringify(params),headers:headers,timeout:36000
  });
};

export const del = (url,params) => {
  return service({
    method:'delete',url:url,params:params
  });
};

/*
 使用示例：
 // GET请求
 this.$api.get(this.$urls.login, {username: 'admin', password: '123456'})
 .then(res => {
 console.log(res);
 this.$message.success('登录成功');
 })
 .catch(err => {
 console.error(err);
 });

 // POST请求
 this.$api.post(this.$urls.add_dev, {name: '新设备', type: 'light'})
 .then(res => {
 console.log(res);
 this.$message.success('添加成功');
 })
 .catch(err => {
 console.error(err);
 });
 */



// WEBPACK FOOTER //
// ./src/utils/api.js